import type { InspectorProfile, InspectorTask, PastAttestation } from './types.js';

/** Seed data for an offline-interactive field/lab inspector device (one credentialed inspector). */

export const PROFILE: InspectorProfile = {
  id: 'insp_8841',
  name: 'M. Haddad',
  kind: 'field_inspector',
  standing: 'active',
  coverage: {
    jurisdictions: ['ae', 'eu', 'uk'],
    asset_classes: ['medical', 'electronics', 'semiconductor'],
    methods: ['physical_inspection', 'manufacturer_callback', 'document_forensics'],
  },
  rating: { sla_hit_rate: 0.97, dispute_rate: 0.02 },
  credentials: [
    { name: 'IEC 62353 field-safety', issuer: 'TÜV SÜD', expires: '2027-03-01' },
    { name: 'Medical-device handling', issuer: 'Garnet Academy', expires: '2026-11-14' },
  ],
};

export const TASKS: InspectorTask[] = [
  {
    id: 'TASK-88',
    method: 'physical_inspection',
    method_label: 'Physical inspection',
    asset: 'Infusion pump, Class IIb',
    supplier: 'Medisource Trading FZE',
    place: 'Jebel Ali Free Zone · DXB',
    jurisdiction: 'ae',
    asset_class: 'medical',
    resolves_check: 'c6_unit',
    resolves_check_label: 'c6 · unit authenticity',
    carrier: '(01)05012345678900(17)271231(10)LOT42(21)SN0007',
    due: 'today 17:00',
    deadline_iso: '2026-06-15T17:00:00.000Z',
    status: 'accepted',
  },
  {
    id: 'TASK-91',
    method: 'manufacturer_callback',
    method_label: 'Manufacturer callback',
    asset: 'ECG monitor, Class IIa',
    supplier: 'Gulf Medical Distribution LLC',
    place: 'remote · phone',
    jurisdiction: 'ae',
    asset_class: 'medical',
    resolves_check: 'c6_unit',
    resolves_check_label: 'c6 · unit authenticity',
    carrier: '(01)04055551234560(21)EM-22417',
    due: 'tomorrow 12:00',
    deadline_iso: '2026-06-16T12:00:00.000Z',
    status: 'offered',
  },
  {
    id: 'TASK-93',
    method: 'document_forensics',
    method_label: 'Document forensics',
    asset: 'CE certificate (MDR) · BSI 0086',
    supplier: 'Medisource Trading FZE',
    place: 'remote · document',
    jurisdiction: 'eu',
    asset_class: 'medical',
    resolves_check: 'c4_certificate',
    resolves_check_label: 'c4 · certificate linkage',
    carrier: 'CERT-MDR-0086-44192',
    due: 'in 2 days',
    deadline_iso: '2026-06-17T17:00:00.000Z',
    status: 'offered',
  },
  {
    id: 'TASK-95',
    method: 'physical_inspection',
    method_label: 'Physical inspection',
    asset: 'Power MOSFET reel, automotive grade',
    supplier: 'Crescent Components DMCC',
    place: 'Dubai Investments Park',
    jurisdiction: 'ae',
    asset_class: 'semiconductor',
    resolves_check: 'c6_unit',
    resolves_check_label: 'c6 · unit authenticity',
    carrier: '(01)00887766554433(10)WAF-9921',
    due: 'in 3 days',
    deadline_iso: '2026-06-18T17:00:00.000Z',
    status: 'offered',
  },
];

export const HISTORY: PastAttestation[] = [
  {
    id: 'ATT-7740',
    method: 'physical_inspection',
    method_label: 'Physical inspection',
    asset: 'Syringe pump, Class IIb',
    supplier: 'Medisource Trading FZE',
    resolves_check_label: 'c6 · unit authenticity',
    outcome: 'confirmed',
    signed_at: '2026-06-09T14:22:00.000Z',
    synced: true,
  },
  {
    id: 'ATT-7711',
    method: 'manufacturer_callback',
    method_label: 'Manufacturer callback',
    asset: 'Patient monitor, Class IIa',
    supplier: 'Gulf Medical Distribution LLC',
    resolves_check_label: 'c6 · unit authenticity',
    outcome: 'inconclusive',
    signed_at: '2026-06-04T10:05:00.000Z',
    synced: true,
  },
  {
    id: 'ATT-7682',
    method: 'document_forensics',
    method_label: 'Document forensics',
    asset: 'Free-sale certificate · DOH',
    supplier: 'Crescent Components DMCC',
    resolves_check_label: 'c4 · certificate linkage',
    outcome: 'refuted',
    signed_at: '2026-05-28T16:48:00.000Z',
    synced: true,
  },
];
